export default __webpack_public_path__ + "static/media/tel-icon.68876459.svg";